import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Gamepad from '../../GamePad';
import Ps4Layout from '../../GamePad/layouts/PS4';
import ArrowsBackground from '../Ps4Share/ArrowsBackground';
import ArrowsBorder from '../Ps4Share/ArrowsBorder';
import Body from '../Ps4Share/Body';
import ButtonsBackground from '../Ps4Share/ButtonsBackground';
import DownArrow from '../Ps4Share/DownArrow';
import L1Button from '../Ps4Share/L1Button';
import L2Button from '../Ps4Share/L2Button';
import LeftArrow from '../Ps4Share/LeftArrow';
import LeftLegBorder from '../Ps4Share/LeftLegBorder';
import LeftStick from '../Ps4Share/LeftStick';
import LeftStickBackground from '../Ps4Share/LeftStickBackground';
import LeftStickBorder from '../Ps4Share/LeftStickBorder';
import OButton from '../Ps4Share/OButton';
import OptionsButton from '../Ps4Share/OptionsButton';
import PsButton from '../Ps4Share/PsButton';
import R1Button from '../Ps4Share/R1Button';
import R2Button from '../Ps4Share/R2Button';
import RightArrow from '../Ps4Share/RightArrow';
import RightLegBorder from '../Ps4Share/RightLegBorder';
import RightStick from '../Ps4Share/RightStick';
import RightStickBackground from '../Ps4Share/RightStickBackground';
import RightStickBorder from '../Ps4Share/RightStickBorder';
import ShareButton from '../Ps4Share/ShareButton';
import SquareButton from '../Ps4Share/SquareButton';
import TouchPad from '../Ps4Share/TouchPad';
import TriangleButton from '../Ps4Share/TriangleButton';
import UpArrow from '../Ps4Share/UpArrow';
import XButton from '../Ps4Share/XButton';

import Speaker from './components/Speaker';

const STICK_OFFSET = 30;

function ControllerPs4Gbest({ data, styles }) {
  const [gamepad, setGamepad] = useState({
    ...Ps4Layout.buttonsDefault,
    ...Ps4Layout.axisDefault,
  });
  const { player } = data;

  const axisChangeHandler = (axisName, value) => {
    setGamepad((prevState) => ({ ...prevState, [axisName]: value }));
  };
  const buttonChangeHandler = (buttonName, value) => {
    setGamepad((prevState) => ({ ...prevState, [buttonName]: value }));
  };

  return (
    <>
      <Gamepad
        gamepadIndex={player}
        layout={Ps4Layout}
        onButtonChange={buttonChangeHandler}
        onAxisChange={axisChangeHandler}
      >
        <svg
          width="800"
          height="600"
          viewBox="0 0 800 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <R2Button
            activeColor={styles.active.color}
            color="#368ABD"
            value={gamepad.RightTrigger}
          />
          <R1Button
            active={gamepad.R1}
            activeColor={styles.active.color}
            color="#368ABD"
          />
          <L1Button
            active={gamepad.L1}
            activeColor={styles.active.color}
            color="#E5152D"
          />
          <L2Button
            activeColor={styles.active.color}
            color="#E5152D"
            value={gamepad.LeftTrigger}
          />
          <Body color={styles?.body?.background} />
          <LeftLegBorder color={styles.legs.background} />
          <RightLegBorder color={styles.legs.background} />
          <ArrowsBackground color={styles.arrows.background} opacity={0.7} />
          <ButtonsBackground color={styles.buttons.background} opacity={0.7} />
          <LeftStickBackground color={styles.sticks.background} opacity={0.7} />
          <g
            style={{
              transform: `translateX(${
                gamepad.LeftStickX * STICK_OFFSET
              }px) translateY(${-gamepad.LeftStickY * STICK_OFFSET}px)`,
            }}
          >
            <LeftStickBorder
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <LeftStick
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <RightStickBackground
            color={styles.sticks.background}
            opacity={0.7}
          />
          <g
            style={{
              transform: `translateX(${
                gamepad.RightStickX * STICK_OFFSET
              }px) translateY(${-gamepad.RightStickY * STICK_OFFSET}px)`,
            }}
          >
            <RightStickBorder
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <RightStick
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <TriangleButton
            active={gamepad.Triangle}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <OButton
            active={gamepad.O}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <XButton
            active={gamepad.X}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <SquareButton
            active={gamepad.Square}
            activeColor={styles.active.color}
            color={styles.buttons.color}
          />
          <UpArrow
            active={gamepad.UpArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <RightArrow
            active={gamepad.RightArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <LeftArrow
            active={gamepad.LeftArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <DownArrow
            active={gamepad.DownArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <ArrowsBorder color={styles.arrows.border} />
          <PsButton
            active={gamepad.Ps}
            activeColor={styles.active.color}
            background={styles.ps.background}
            color={styles.ps.color}
          />
          <Speaker />
          <TouchPad
            active={gamepad.TouchPad}
            activeColor={styles.active.color}
            color={styles.touchpad.background}
          />
          <OptionsButton
            active={gamepad.Options}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <ShareButton
            active={gamepad.Share}
            activeColor={styles.active.color}
            color={styles.options.background}
          />
          <path
            d="M380.32 169.25C381.106 169.825 381.894 170.28 382.532 170.894C385.15 173.403 385.174 176.464 384.137 179.624C383.149 182.639 380.743 184.28 377.953 185.426C375.374 186.485 372.656 186.922 369.883 186.935C363.612 186.966 357.341 186.949 351.067 186.947C350.818 186.947 350.569 186.922 350.233 186.906C350.685 184.604 351.118 182.36 351.565 180.119C353.352 171.199 355.151 162.278 356.92 153.352C357.024 152.822 357.213 152.673 357.737 152.675C363.588 152.692 369.438 152.612 375.287 152.728C377.138 152.764 379.053 153.086 380.816 153.657C386.449 155.477 388.119 161.959 384.183 166.409C383.649 167.014 383.013 167.543 382.36 168.022C381.734 168.486 381.023 168.837 380.32 169.25ZM361.139 179.933C361.422 179.969 361.56 180.003 361.695 180.003C364.449 180.006 367.207 180.066 369.958 179.972C370.998 179.936 372.086 179.679 373.045 179.273C374.639 178.601 375.388 176.962 375.067 175.328C374.801 173.974 373.763 173.113 371.936 173.05C368.96 172.949 365.979 172.98 363 172.99C362.812 172.99 362.495 173.251 362.456 173.437C362 175.569 361.584 177.711 361.139 179.933ZM365.193 159.722C364.76 161.917 364.34 164.062 363.909 166.247C366.74 166.247 369.402 166.298 372.059 166.216C372.84 166.192 373.662 165.902 374.375 165.553C375.688 164.915 376.389 163.337 376.123 161.942C375.879 160.66 374.936 159.804 373.314 159.749C370.652 159.657 367.985 159.722 365.193 159.722Z"
            fill="white"
          />
          <path
            d="M398.974 179.384C408.715 179.384 418.428 179.384 428.21 179.384C428.009 179.938 427.801 180.535 427.574 181.125C426.97 182.694 426.322 184.246 425.766 185.832C425.534 186.497 425.21 186.719 424.499 186.719C419.132 186.727 413.762 186.78 408.395 186.818C401.931 186.864 395.466 186.908 389.002 186.951C388.668 186.954 388.337 186.951 387.875 186.951C388.163 185.465 388.424 184.075 388.699 182.687C390.653 172.913 392.616 163.138 394.557 153.362C394.647 152.909 394.755 152.68 395.282 152.68C406.5 152.694 417.72 152.692 428.938 152.694C429.01 152.694 429.085 152.731 429.295 152.786C428.635 153.316 428.06 153.787 427.477 154.246C425.207 156.038 422.947 157.846 420.645 159.599C420.259 159.894 419.693 160.092 419.207 160.095C414.033 160.131 408.86 160.136 403.686 160.097C402.903 160.092 402.608 160.339 402.487 161.083C402.228 162.679 401.895 164.262 401.568 165.977C406.186 165.977 410.695 165.977 415.428 165.977C414.836 166.772 414.379 167.391 413.917 168.007C412.776 169.538 411.616 171.053 410.499 172.603C410.184 173.041 409.848 173.205 409.312 173.2C406.5 173.176 403.688 173.195 400.877 173.183C400.417 173.181 400.064 173.217 399.963 173.783C399.641 175.548 399.284 177.305 398.948 179.065C398.931 179.164 398.964 179.276 398.974 179.384Z"
            fill="white"
          />
          <path
            d="M350.656 158.31C348.345 160.133 346.077 161.925 343.834 163.694C343.728 163.658 343.657 163.656 343.631 163.619C340.389 159.439 334.468 159.398 330.752 160.803C326.563 162.389 323.877 166.562 323.763 171.389C323.688 174.549 324.689 177.129 327.595 178.594C330.503 180.059 333.574 179.962 336.62 178.961C336.876 178.877 337.132 178.468 337.195 178.168C337.788 175.4 338.339 172.625 338.897 169.849C338.982 169.429 339.016 169.047 339.635 169.054C342.137 169.083 344.641 169.066 347.144 169.073C347.25 169.073 347.354 169.122 347.55 169.168C347.228 170.807 346.916 172.424 346.595 174.039C346.022 176.926 345.417 179.807 344.886 182.704C344.753 183.427 344.356 183.821 343.798 184.181C341.08 185.936 338.095 186.944 334.906 187.379C331.212 187.882 327.556 187.742 324.002 186.521C318.205 184.527 313.566 179.619 314.032 171.196C314.555 161.775 321.077 154.244 330.428 152.523C335.152 151.652 339.826 151.744 344.361 153.514C346.875 154.493 348.957 156.069 350.656 158.31Z"
            fill="white"
          />
          <path
            d="M449.586 160.382C450.476 157.701 451.303 155.209 452.127 152.721C463.487 152.721 474.787 152.721 486.174 152.721C485.652 155.279 485.139 157.788 484.615 160.356C482.502 160.356 480.454 160.356 478.406 160.356C477.224 160.356 476.044 160.38 474.864 160.346C474.296 160.329 474.103 160.542 473.994 161.091C472.333 169.446 470.648 177.796 468.973 186.149C468.888 186.577 468.866 186.964 468.252 186.959C465.356 186.937 462.46 186.947 459.564 186.939C459.481 186.939 459.402 186.903 459.191 186.85C461.263 178.06 463.335 169.276 465.433 160.382C460.132 160.382 454.944 160.382 449.586 160.382Z"
            fill="white"
          />
          <path
            d="M448.962 146C447.616 149.566 446.371 152.893 445.089 156.205C444.983 156.483 444.652 156.703 444.379 156.882C440.968 159.152 437.547 161.41 434.133 163.675C433.908 163.825 433.7 163.996 433.342 164.265C434.073 164.383 434.636 164.475 435.361 164.594C433.986 165.698 432.707 166.724 431.428 167.746C431.362 167.799 431.28 167.836 431.227 167.898C429.866 169.545 428.13 169.77 426.172 169.276C425.551 169.119 424.893 169.098 424.252 169.015C422.949 168.849 422.176 168.239 421.912 167.178C421.629 166.035 421.985 165.13 423.07 164.354C425.925 162.314 428.79 160.285 431.65 158.252C437.167 154.336 442.684 150.419 448.203 146.503C448.385 146.377 448.573 146.259 448.962 146Z"
            fill="white"
          />
          <path
            d="M427.458 192.345C428.73 189.362 430.062 186.4 431.249 183.385C431.762 182.082 432.555 181.217 433.751 180.516C436.585 178.855 439.348 177.076 442.135 175.34C442.336 175.214 442.525 175.067 442.907 174.796C442.06 174.68 441.437 174.595 440.721 174.496C440.852 174.334 440.927 174.199 441.04 174.109C442.945 172.627 444.848 171.14 446.777 169.687C447.036 169.492 447.444 169.373 447.766 169.402C449.33 169.542 450.894 169.712 452.446 169.939C453.546 170.101 454.281 170.775 454.533 171.871C454.787 172.975 454.38 173.858 453.462 174.496C450.491 176.565 447.515 178.628 444.538 180.692C439.118 184.452 433.696 188.211 428.273 191.968C428.043 192.127 427.811 192.28 427.582 192.437C427.543 192.408 427.499 192.376 427.458 192.345Z"
            fill="white"
          />
          <path
            d="M443.448 160.402C442.454 163.063 441.463 165.723 440.436 168.471C441.828 168.648 443.097 168.81 444.623 169.003C440.37 172.209 436.285 175.289 432.196 178.369C432.158 178.335 432.117 178.301 432.078 178.267C433.188 175.685 434.3 173.103 435.455 170.413C434.085 170.229 432.827 170.057 431.345 169.859C435.453 166.581 439.386 163.44 443.322 160.298C443.368 160.334 443.409 160.368 443.448 160.402Z"
            fill="white"
          />
          <path
            d="M361.973 206.188C361.12 206.188 360.377 206.188 359.526 206.188C359.526 204.88 359.526 203.625 359.526 202.368C359.526 202.059 359.536 201.749 359.522 201.442C359.466 200.306 358.973 199.76 357.982 199.721C356.952 199.68 356.154 200.287 356.074 201.329C355.985 202.53 356.023 203.739 356.009 204.945C356.004 205.332 356.009 205.719 356.009 206.174C355.18 206.174 354.437 206.174 353.627 206.174C353.627 203.384 353.627 200.594 353.627 197.746C354.35 197.746 355.066 197.746 355.82 197.746C355.854 197.99 355.89 198.232 355.934 198.536C357.853 197.245 359.691 197.168 361.468 198.877C362.287 198.058 363.283 197.615 364.463 197.598C366.494 197.569 367.843 198.643 367.981 200.654C368.104 202.465 368.007 204.29 368.007 206.176C367.2 206.176 366.433 206.176 365.561 206.176C365.561 204.593 365.587 203.028 365.553 201.467C365.522 200.047 364.376 199.31 363.109 199.864C362.348 200.197 362.062 200.872 362.026 201.633C361.973 202.726 361.987 203.821 361.975 204.914C361.968 205.303 361.973 205.695 361.973 206.188Z"
            fill="white"
          />
          <path
            d="M431.582 198.51C433.993 197.183 435.318 197.277 437.138 198.877C438.134 197.886 439.357 197.485 440.776 197.635C442.372 197.804 443.542 198.841 443.62 200.446C443.711 202.32 443.641 204.201 443.641 206.162C442.897 206.162 442.159 206.162 441.284 206.162C441.284 205.499 441.296 204.837 441.282 204.174C441.258 203.14 441.255 202.1 441.166 201.068C441.098 200.28 440.619 199.794 439.795 199.726C438.963 199.658 438.255 199.922 437.941 200.727C437.755 201.206 437.713 201.764 437.701 202.289C437.67 203.572 437.692 204.856 437.692 206.191C436.838 206.191 436.096 206.191 435.245 206.191C435.245 204.921 435.247 203.696 435.245 202.467C435.245 202.076 435.262 201.679 435.214 201.29C435.088 200.292 434.609 199.789 433.761 199.719C432.789 199.637 432.008 200.113 431.824 201.073C431.672 201.861 431.698 202.685 431.679 203.495C431.657 204.36 431.674 205.228 431.674 206.166C430.872 206.166 430.132 206.166 429.3 206.166C429.276 205.944 429.23 205.705 429.23 205.468C429.225 203.137 429.247 200.809 429.213 198.478C429.204 197.843 429.409 197.598 430.033 197.678C430.255 197.707 430.485 197.707 430.707 197.678C431.275 197.601 431.633 197.768 431.582 198.51Z"
            fill="white"
          />
          <path
            d="M392.688 198.597C392.722 198.273 392.746 198.024 392.775 197.731C393.51 197.731 394.226 197.731 395.05 197.731C395.05 198.718 395.05 199.663 395.05 200.606C395.05 202.037 395.043 203.468 395.053 204.9C395.077 208.741 392.664 209.507 390.152 209.493C388.757 209.486 387.35 209.285 386.096 208.316C386.4 207.752 386.7 207.199 387.019 206.614C388.281 207.329 389.562 207.757 390.989 207.436C392.164 207.17 392.729 206.278 392.49 205.078C389.753 206.28 387.611 205.939 386.33 204.097C385.22 202.504 385.407 200.178 386.751 198.827C388.25 197.316 390.602 197.197 392.688 198.597ZM390.433 199.615C389.026 199.607 388.114 200.429 388.114 201.706C388.112 202.924 389.05 203.841 390.329 203.872C391.615 203.903 392.657 202.951 392.674 201.728C392.688 200.507 391.75 199.622 390.433 199.615Z"
            fill="white"
          />
          <path
            d="M339.105 200.57C339.922 200.57 340.614 200.57 341.407 200.57C341.407 202.008 341.416 203.401 341.395 204.793C341.392 204.953 341.249 205.163 341.109 205.255C338.544 206.979 333.774 207.155 331.681 203.734C329.365 199.953 331.944 195.142 336.38 194.954C338.331 194.871 340.123 195.232 341.624 196.825C341.087 197.325 340.57 197.806 340.024 198.319C338.827 197.243 337.5 196.81 335.957 197.245C334.212 197.736 333.233 199.288 333.453 201.203C333.651 202.929 335.051 204.206 336.813 204.261C337.038 204.269 337.263 204.266 337.488 204.254C338.907 204.177 339.105 203.969 339.105 202.569C339.105 201.933 339.105 201.292 339.105 200.57Z"
            fill="white"
          />
          <path
            d="M402.235 195.176C404.996 195.176 407.733 195.176 410.513 195.176C410.513 195.8 410.513 196.38 410.513 197.12C410.172 197.12 409.824 197.12 409.476 197.12C408.1 197.12 406.722 197.127 405.347 197.117C404.924 197.115 404.689 197.197 404.658 197.712C404.505 200.168 404.491 200.166 406.935 200.166C407.885 200.166 408.833 200.166 409.831 200.166C409.831 200.85 409.831 201.452 409.831 202.187C408.456 202.187 407.09 202.238 405.726 202.168C404.875 202.124 404.576 202.373 404.65 203.241C404.73 204.184 404.667 205.141 404.667 206.164C403.843 206.164 403.074 206.164 402.233 206.164C402.235 202.528 402.235 198.877 402.235 195.176Z"
            fill="white"
          />
          <path
            d="M416.003 197.598C418.779 197.591 420.703 199.4 420.701 202.011C420.698 204.564 418.769 206.374 416.047 206.377C413.25 206.379 411.304 204.595 411.299 202.015C411.292 199.421 413.226 197.606 416.003 197.598ZM418.216 202.008C418.225 200.56 417.348 199.61 416.003 199.615C414.688 199.617 413.808 200.533 413.784 201.926C413.76 203.328 414.676 204.37 415.965 204.397C417.261 204.426 418.206 203.422 418.216 202.008Z"
            fill="white"
          />
          <path
            d="M454.547 206.241C454.027 206.241 453.58 206.246 453.135 206.239C452.886 206.236 452.635 206.217 452.357 206.203C452.316 205.963 452.279 205.748 452.233 205.489C452.122 205.521 452.023 205.543 451.931 205.579C451.293 205.84 450.672 206.273 450.014 206.338C447.451 206.592 445.972 205.202 445.938 202.622C445.921 201.22 445.953 199.818 445.926 198.418C445.916 197.893 446.054 197.632 446.632 197.673C447.183 197.712 447.739 197.681 448.385 197.681C448.385 199.291 448.36 200.797 448.392 202.303C448.423 203.79 449.337 204.525 450.691 204.211C451.564 204.007 452.125 203.214 452.137 202.098C452.154 200.671 452.142 199.242 452.142 197.748C452.959 197.748 453.728 197.748 454.552 197.748C454.547 200.545 454.547 203.331 454.547 206.241Z"
            fill="white"
          />
          <path
            d="M348.741 201.189C348.57 199.356 346.921 199.015 344.308 200.248C344.037 199.719 343.766 199.187 343.5 198.667C345.018 197.465 348.14 197.245 349.711 198.176C350.485 198.636 351.065 199.322 351.106 200.176C351.203 202.153 351.137 204.138 351.137 206.181C350.499 206.181 349.81 206.181 349.063 206.181C349.012 205.978 348.957 205.751 348.879 205.439C347.767 206.459 346.512 206.558 345.209 206.256C343.843 205.939 343.048 204.912 343.123 203.681C343.198 202.429 344.076 201.549 345.495 201.375C346.273 201.28 347.061 201.273 347.847 201.23C348.142 201.213 348.439 201.203 348.741 201.189ZM348.737 202.613C347.886 202.678 347.047 202.675 346.239 202.837C345.966 202.893 345.613 203.36 345.599 203.655C345.584 203.959 345.91 204.525 346.133 204.547C346.79 204.614 347.518 204.602 348.125 204.373C348.739 204.14 348.954 203.5 348.737 202.613Z"
            fill="white"
          />
          <path
            d="M466.804 201.23C466.669 199.383 465.139 199.073 462.37 200.226C462.109 199.721 461.846 199.206 461.587 198.703C463.072 197.376 466.608 197.156 468.066 198.406C468.617 198.877 469.147 199.675 469.203 200.364C469.357 202.279 469.256 204.213 469.256 206.13C467.629 206.452 467.162 206.328 466.915 205.489C465.794 206.498 464.486 206.58 463.13 206.212C461.863 205.871 461.229 205.008 461.234 203.768C461.241 202.571 461.853 201.783 463.168 201.484C463.927 201.309 464.723 201.297 465.504 201.237C465.919 201.203 466.338 201.23 466.804 201.23ZM466.749 202.61C465.919 202.673 465.11 202.668 464.334 202.83C464.043 202.891 463.635 203.343 463.64 203.611C463.644 203.942 463.993 204.518 464.244 204.549C464.892 204.626 465.615 204.588 466.222 204.36C466.87 204.116 466.969 203.449 466.749 202.61Z"
            fill="white"
          />
          <path
            d="M377.533 206.193C376.694 206.193 375.978 206.193 375.195 206.193C375.195 203.367 375.195 200.582 375.195 197.741C375.952 197.741 376.667 197.741 377.421 197.741C377.465 197.988 377.506 198.22 377.508 198.239C378.57 198.026 379.585 197.659 380.603 197.656C382.472 197.649 383.635 198.706 383.772 200.57C383.91 202.405 383.801 204.256 383.801 206.174C383.025 206.174 382.286 206.174 381.406 206.174C381.406 205.494 381.406 204.805 381.406 204.116C381.406 203.275 381.423 202.431 381.401 201.592C381.372 200.408 380.833 199.798 379.786 199.721C378.64 199.636 377.779 200.255 377.649 201.389C377.535 202.359 377.557 203.345 377.533 204.327C377.521 204.909 377.533 205.497 377.533 206.193Z"
            fill="white"
          />
          <path
            d="M459.303 206.207C458.534 206.207 457.838 206.207 457.062 206.207C457.062 202.31 457.062 198.44 457.062 194.509C457.789 194.509 458.505 194.509 459.303 194.509C459.303 198.375 459.303 202.245 459.303 206.207Z"
            fill="white"
          />
          <path
            d="M424.864 206.186C423.996 206.186 423.254 206.186 422.468 206.186C422.468 203.347 422.468 200.565 422.468 197.734C423.235 197.734 423.95 197.734 424.685 197.734C424.719 198.036 424.75 198.304 424.767 198.464C425.669 198.128 426.554 197.799 427.589 197.415C427.589 198.343 427.589 199.001 427.589 199.661C427.545 199.694 427.507 199.755 427.461 199.76C425.372 199.987 424.866 200.548 424.864 202.661C424.862 203.824 424.864 204.991 424.864 206.186Z"
            fill="white"
          />
          <path
            d="M370.333 206.181C370.333 203.367 370.333 200.596 370.333 197.756C371.097 197.756 371.866 197.756 372.695 197.756C372.695 200.546 372.695 203.333 372.695 206.181C371.912 206.181 371.145 206.181 370.333 206.181Z"
            fill="white"
          />
          <path
            d="M371.544 196.44C370.64 196.44 370.023 195.918 369.997 195.128C369.97 194.318 370.625 193.742 371.566 193.754C372.48 193.767 373.094 194.315 373.067 195.096C373.038 195.889 372.417 196.44 371.544 196.44Z"
            fill="white"
          />
        </svg>
      </Gamepad>
    </>
  );
}

ControllerPs4Gbest.propTypes = {
  data: PropTypes.shape({
    player: PropTypes.number,
  }),
  styles: PropTypes.shape({
    active: PropTypes.shape({
      color: PropTypes.string,
    }),
    arrows: PropTypes.shape({
      color: PropTypes.string,
      background: PropTypes.string,
      border: PropTypes.string,
    }),
    body: PropTypes.shape({
      background: PropTypes.string,
    }),
    buttons: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    legs: PropTypes.shape({
      background: PropTypes.string,
    }),
    options: PropTypes.shape({
      background: PropTypes.string,
    }),
    ps: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    sticks: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    touchpad: PropTypes.shape({
      background: PropTypes.string,
    }),
  }),
};

ControllerPs4Gbest.defaultProps = {
  data: {
    player: 0,
  },
  styles: {
    active: {
      color: '#E2BA2A',
    },
    arrows: {
      color: '#E5152D',
      background: '#1E1E1E',
      border: '#4F535E',
    },
    body: {
      background: '#111111',
    },
    buttons: {
      background: '#1E1E1E',
      color: '#464A56',
    },
    legs: {
      background: '#383D43',
    },
    options: {
      background: '#4F535F',
    },
    ps: {
      background: '#FFFFFF',
      color: '#000000',
    },
    sticks: {
      background: '#32353A',
      border: '#393E42',
      color: '#32353A',
    },
    touchpad: {
      background: '#1E1E1E',
    },
  },
};

export default ControllerPs4Gbest;
